// 
import { isInProgress } from '../partialUpdate/XHRQueue';

let cursorState = {
  left: 10,
  top: 10,
  visible: true,
  show: false,
  progresses: [],
};
let cursorElement;

export const setCursorState = (newState) => {
  cursorState = {
    ...cursorState,
    ...newState,
  };

  const {
    left,
    top,
    visible,
    show,
    progresses,
  } = cursorState;
  const hidden = (!show || !visible) && progresses.length === 0;

  if (hidden) {
    if (cursorElement) {
      cursorElement.remove();
      cursorElement = null;
    }
    return;
  }

  if (!cursorElement) {
    cursorElement = document.createElement('div');
    cursorElement.classList.add('cursor-spinner');
    cursorElement.innerHTML = `<span class="cursor-spinner__1"></span><span class="cursor-spinner__2"></span><span class="cursor-spinner__3"></span><img class="cursor-spinner__img" src="data:image/gif;base64,R0lGODlhEAAQAKIGANjY2O7u7mRkZAQEBE5OTr6+vv///wAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFAAAGACwAAAAAEAAQAAADKWi63P4wykkVuMBijUPIBuCB4leSozWe6tdeaRifrOza2MWRW+X/wEYCACH5BAkKAAYALAAAAwAEAAsAAAMLOKpE7KO9GaGsdCUAIfkECQoABgAsAAAAABAAEAAAAzFoutz+MMZBhxNYqEGIbUJRaAbnXSJpfkw4bh27uGqMvqUNpvC546tLpieDVIqSpDIBACH5BAkKAAYALAAAAAAQABAAAAM9aLrc/jDKNupwIgs1CBlACChCUWxG9wFBMBrlyXlg+8aoWrukmdMsHsw3W9l6shRQhPx9MJriZWKZTq6PBAAh+QQFCgAGACwAAAAAEAAQAAADMmi63P4wyimFFSADpbcRRYEFgQeQHiieJYcq6tgabBrK5vvdtTvHHY4GdqNcBJSkMpIAACH5BAkKAAYALAYAAwAKAAsAAAMYODrWPoQw16CkNU5q99OY0YUjVnKguYQJACH5BAkKAAYALAAAAAAQABAAAAM8aLrc/jCuQYdUgxBrhBdOtilCUYAGoAIiV54KEASs5pqoTLckHs+1UceXAvKGsOLO1kuugq5PqHKpWiEJACH5BAkKAAYALAAAAAAQABAAAAMzaLrc/jDKKKqYRpRyDfiAAgIaJwZB6KHk1gHsmZZvvM6urMK4ee8smgg0/Fg6mKRyyUgAACH5BAUKAAYALAAAAAAQABAAAAMpaLrc/jDKSRW4wGKNQ8gG4IHiV5KjNZ7q115pGJ+s7NrYxZFb5f/ARgIAIfkEBSMABgAsAAAAAAEAAQAAAwJoCQA7" style="width:16px;height:16px;" />`;
    cursorElement.style.position = 'fixed';
    cursorElement.style.overflow = 'hidden';
    cursorElement.style.zIndex = 1000000;
    document.body.appendChild(cursorElement);
  }

  cursorElement.style.display = hidden ? 'none' : 'block';
  cursorElement.style.left = `${left}px`;
  cursorElement.style.top = `${top}px`;
};

const handleMouseMove = ({ clientX, clientY }) => {
  const newState = {
    left: clientX + 18,
    top: clientY + 18,
    visible: true,
  };
  if (clientX < 10 || clientY < 10) {
    newState.visible = false;
  }
  if (clientX >= window.innerWidth - 50 || clientY >= window.innerHeight - 50) {
    newState.visible = false;
  }
  setCursorState(newState);
};

document.addEventListener('mousemove', handleMouseMove);

// Na základě stavu se zobrazuje loader
// loader se zobrazí jen pokud akce trvá déle než 210ms
// je to doba po které uživatel registruje prodlevu
let progressUpdateTimeout;

/**
 *  Přidání procesu do fronty spinneru.
 *  Spinner se zobrazuje pokud fronta obsahuje alespoň jedenu položku
 */
export const pushToQueue = (progressId) => {
  const newProgress = [...cursorState.progresses];
  newProgress.push(progressId);
  setCursorState({
    progresses: newProgress,
  });
};

/**
 * Odebrání prosesu z fronty spinneru
 */
export const removeFromQueue = (progressId) => {
  setCursorState({
    progresses: [...cursorState.progresses].filter((item) => item !== progressId),
  });
};

/**
 * Handler pro změnu fronty XHR z partial updatu
 */
export const onChangeXHRQueue = () => {
  clearTimeout(progressUpdateTimeout);
  const progress = isInProgress();
  if (progress) {
    progressUpdateTimeout = setTimeout(() => {
      setCursorState({ show: isInProgress() });
    }, 210);
  } else {
    setCursorState({ show: isInProgress() });
  }
};




// WEBPACK FOOTER //
// ./node_modules/@fg/fg-frontend/src/components/CursorSpinner.js